import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function IsolationMursPage() {
  const travail = getTravailStub('isolation-murs');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
